"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.resultItemInfiniteScrollSagas = void 0;
var effects_1 = require("redux-saga/effects");
var GlobalAction_1 = require("@/pages/common/actions/GlobalAction");
var ResultAction_1 = require("@/pages/search/actions/sfilter/ResultAction");
var WindowApi_1 = require("@/api/browser/WindowApi");
var ResultSaga_1 = require("@/pages/search/sagas/ResultSaga");
var getInfinteLoadEnabled = function (state) { return state.results.isInfiniteLoadEnabled; };
var getThresholdPosition = function (state) { return state.results.lastItemPosition; };
/**
 * Save pageY position of `Last Item` in order to trigger a reload
 * when the scrollbar has reach that position
 * `Last Item` in context of infinite scroll triggering item, may
 * not necessary really be the last result item
 */
var watchOnGlobalWindowResize = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.take(GlobalAction_1.default.ON_WINDOW_RESIZE)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(ResultAction_1.default.onUpdateLastItemPosition())];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.put(ResultAction_1.default.onUpdateInfiniteLoadEnable())];
            case 3:
                _a.sent();
                return [3 /*break*/, 0];
            case 4: return [2 /*return*/];
        }
    });
};
var watchOnInfiniteLoadEnable = function () {
    var screenSize;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 7];
                return [4 /*yield*/, effects_1.take(ResultAction_1.default.ON_UPDATE_INFINITE_LOAD_ENABLE)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.call(WindowApi_1.getScreenSize)];
            case 2:
                screenSize = _a.sent();
                if (!(screenSize > 768)) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.put(ResultAction_1.default.setInfiniteLoadEnable(false))];
            case 3:
                _a.sent();
                return [3 /*break*/, 6];
            case 4: return [4 /*yield*/, effects_1.put(ResultAction_1.default.setInfiniteLoadEnable(true))];
            case 5:
                _a.sent();
                _a.label = 6;
            case 6: return [3 /*break*/, 0];
            case 7: return [2 /*return*/];
        }
    });
};
var watchOnGlobalWindowScroll = function () {
    var action;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.take(GlobalAction_1.default.ON_DOM_LOADED)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.delay(3000)];
            case 2:
                _a.sent();
                _a.label = 3;
            case 3:
                if (!true) return [3 /*break*/, 6];
                return [4 /*yield*/, effects_1.take(GlobalAction_1.default.ON_WINDOW_SCROLL)];
            case 4:
                action = _a.sent();
                return [4 /*yield*/, effects_1.put(ResultAction_1.default.checkLoadNextPage(action.payload))];
            case 5:
                _a.sent();
                return [3 /*break*/, 3];
            case 6: return [2 /*return*/];
        }
    });
};
var watchUpdateLastChildPosition = function () {
    var lastItemY;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.take(ResultAction_1.default.ON_UPDATE_LAST_CHILD_POSITION)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.call(WindowApi_1.updateLastCellPosition)];
            case 2:
                lastItemY = _a.sent();
                return [4 /*yield*/, effects_1.put(ResultAction_1.default.setLastItemPosition(lastItemY))];
            case 3:
                _a.sent();
                return [3 /*break*/, 0];
            case 4: return [2 /*return*/];
        }
    });
};
var watchCheckLoadNextPage = function () {
    var payload, thresholdPosition, isInfinteLoadEnabled, isLoading;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 7];
                return [4 /*yield*/, effects_1.take(ResultAction_1.default.CHECK_LOAD_NEXT_PAGE)];
            case 1:
                payload = (_a.sent()).payload;
                return [4 /*yield*/, effects_1.select(getThresholdPosition)];
            case 2:
                thresholdPosition = _a.sent();
                return [4 /*yield*/, effects_1.select(getInfinteLoadEnabled)];
            case 3:
                isInfinteLoadEnabled = _a.sent();
                return [4 /*yield*/, effects_1.select(ResultSaga_1.getIsLoading)];
            case 4:
                isLoading = _a.sent();
                if (!(payload > thresholdPosition && !isLoading && isInfinteLoadEnabled)) return [3 /*break*/, 6];
                return [4 /*yield*/, effects_1.put(ResultAction_1.default.loadNextPage())];
            case 5:
                _a.sent();
                _a.label = 6;
            case 6: return [3 /*break*/, 0];
            case 7: return [2 /*return*/];
        }
    });
};
var resultItemInfiniteScrollSagas = {
    watchOnGlobalWindowResize: watchOnGlobalWindowResize,
    watchOnInfiniteLoadEnable: watchOnInfiniteLoadEnable,
    watchOnGlobalWindowScroll: watchOnGlobalWindowScroll,
    watchUpdateLastChildPosition: watchUpdateLastChildPosition,
    watchCheckLoadNextPage: watchCheckLoadNextPage,
};
exports.resultItemInfiniteScrollSagas = resultItemInfiniteScrollSagas;
